var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585786 0.585787C0.960859 0.210714 1.46957 0 2 0H11C11.5523 0 12 0.447715 12 1H16C16.3513 1 16.6768 1.1843 16.8575 1.4855L19.8575 6.4855C19.9507 6.64092 20 6.81876 20 7V13C20 13.5523 19.5523 14 19 14H17.8293C17.4175 15.1652 16.3062 16 15 16C13.6938 16 12.5825 15.1652 12.1707 14H7.82929C7.41746 15.1652 6.30622 16 5 16C3.69378 16 2.58254 15.1652 2.17071 14H1C0.447715 14 0 13.5523 0 13V2C0 1.46957 0.210714 0.960859 0.585786 0.585787ZM2.17071 12C2.58254 10.8348 3.69378 10 5 10C6.30622 10 7.41746 10.8348 7.82929 12H10V2L2 2V12H2.17071ZM12 3V6H17.2338L15.4338 3H12ZM18 8H12V12H12.1707C12.5825 10.8348 13.6938 10 15 10C16.3062 10 17.4175 10.8348 17.8293 12H18V8ZM5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14C5.55228 14 6 13.5523 6 13C6 12.4477 5.55228 12 5 12ZM15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.75e4c74359185bd1d170b233a0441a95.svg";
export { ForwardRef as ReactComponent };